var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-box",style:({ height: _vm.contentHeight + 'px' }),on:{"click":_vm.refresh}},[_c('canvas',{staticClass:"id-canvas",attrs:{"id":"id-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }